import { jsx, jsxs } from 'react/jsx-runtime';
import { styled, Icon } from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const Container = styled('div')(({ theme }) => ({
    '.arrow-text': {
        fontSize: 14,
        fontWeight: 600,
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        color: theme.vars.palette.text.primary,
        margin: `5px 0`,
        ':hover': {
            cursor: 'pointer',
        },
    },
}));
const IconComponent = (jsx(Icon, Object.assign({ sx: (theme) => ({ color: theme.vars.palette.primary.main }) }, { children: jsx(ArrowRightAltIcon, {}) })));
const ArrowLink = ({ text, url, Link, onTextClick }) => {
    const handleClick = () => {
        if (onTextClick)
            onTextClick();
    };
    return (jsx(Container, { children: Link && url ? (jsxs(Link, Object.assign({ to: url, style: { textDecoration: 'none' }, className: "arrow-text" }, { children: [text, IconComponent] }))) : (jsxs("div", Object.assign({ onClick: handleClick, className: "arrow-text" }, { children: [text, IconComponent] }))) }));
};

export { ArrowLink };
//# sourceMappingURL=ArrowLink.js.map
